import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { Ticket } from '@zero/shared/util-models';

export const TicketsPageActions = createActionGroup({
  source: 'Tickets Page',
  events: {
    'Load Tickets Deprecated': props<{ force: boolean }>(),
    'Load Tickets': props<{ force: boolean; page?: number; size?: number; status?: 'OPEN' | 'CLOSED' | 'ALL' }>(),
    'Load Unread Tickets Count': props<{ force: boolean }>(),
    'Set Ticket Loading': props<{ ticketsLoading: boolean }>(),
  },
});

export const TicketsApiActions = createActionGroup({
  source: 'Tickets API',
  events: {
    'Load Tickets Deprecated Success': props<{ tickets: Ticket[] }>(),
    'Load Tickets Deprecated Failure': props<{ error: HttpErrorResponse }>(),
    'Load Tickets Success': props<{ tickets: Ticket[]; ticketsHasNext: boolean }>(),
    'Load Tickets Failure': props<{ error: HttpErrorResponse }>(),
    'Load Unread Tickets Count Success': props<{ unreadTicketsCount: number }>(),
    'Load Unread Tickets Count Failure': props<{ error: HttpErrorResponse }>(),
  },
});
